module.exports = __webpack_public_path__ + "img/tati.94f99b81.png";